import React from 'react';
import { signIn } from 'next-auth/react';
import { useRouter } from '@/intl/navigation';
import { Service } from './Service';
import httpCodes from '@/constants/httpCodes';
import { ErrorType } from '@/ui/features/authentication/components/errorAlert';
import appRoutes from '@/constants/routes';

export function useController() {
  const [loading, setLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState(ErrorType.NONE);
  const router = useRouter();

  const handleLogin = async (payload: { email: string; password: string }) => {
    setLoading(true);
    try {
      const { status, data } = await Service.login(payload);

      if (status === httpCodes.SUCCESS && data) {
        const saveSession = await signIn('credentials', {
          email: JSON.stringify(data.data),
          password: '',
          redirect: false,
        });

        if (!saveSession?.error) {
          if (data.data.role === 'USER') {
            router.push(appRoutes.users);
          } else if (['ADMIN', 'SUPER_ADMIN'].includes(data.data.role)) {
            router.push(appRoutes.admin);
          }
        } else {
          throw new Error('LoginError: Failed to save session');
        }
      } else {
        handleApiError(status);
      }
      // stop loading
      setLoading(false);
    } catch (error) {
      setApiError(ErrorType.UNEXPECTED);
      setLoading(false);
    }
  };

  const handleApiError = (status: number) => {
    switch (status) {
      case httpCodes.BAD_REQUEST:
        setApiError(ErrorType.BAD_REQUEST);
        break;
      case httpCodes.NOT_FOUND:
        setApiError(ErrorType.NOT_FOUND);
        break;
      case httpCodes.ACCES_DENIED:
        setApiError(ErrorType.DENIED);
        break;
      default:
        setApiError(ErrorType.UNEXPECTED);
    }
  };

  return { loading, apiError, handleLogin };
}
